import { u as useHead } from './shared/vue.-sixQ7xP.mjs';
import 'vue';
import './shared/vue.ziyDaVMR.mjs';
import 'unhead';
import '@unhead/shared';

function polyfillAsVueUseHead(head) {
  const polyfilled = head;
  polyfilled.headTags = head.resolveTags;
  polyfilled.addEntry = head.push;
  polyfilled.addHeadObjs = head.push;
  polyfilled.addReactiveEntry = (input, options) => {
    const api = useHead(input, options);
    if (api !== void 0)
      return api.dispose;
    return () => {
    };
  };
  polyfilled.removeHeadObjs = () => {
  };
  polyfilled.updateDOM = () => {
    head.hooks.callHook("entries:updated", head);
  };
  polyfilled.unhead = head;
  return polyfilled;
}

export { polyfillAsVueUseHead };
